import _merge from 'lodash/merge';
import _find from 'lodash/find';
import _forEach from 'lodash/forEach';
import _findKey from 'lodash/findKey';
import _size from 'lodash/size';
import _isUndefined from 'lodash/isUndefined';
import _cloneDeep from 'lodash/cloneDeep';
import _sortBy from 'lodash/sortBy';
import _toArray from 'lodash/toArray';
import _intersectionBy from 'lodash/intersectionBy';
import _head from 'lodash/head';
import _filter from 'lodash/filter';
import _at from 'lodash/at';

/**
 * @class
 * @memberof InstanceVariants
 * @alias options
 *
 * @description
 * Класс для работы с опциями экземпляра
 */

var InstanceOptions = function(_options, _settings) {
  var self = this;

  self.options = _options;
  self.setConfig(_settings);

  return self;
};

/**
 * @private
 * Получаем опции
 */
InstanceOptions.prototype._getOptions = function() {
  var self = this;
  var _options;

  if (!self.options) {
    self.options = [];
  }

  _options = self.options;

  return _options;
};

/**
 * @method
 *
 * @description
 * Устанавливаем указанную опцию
 *
 * @param {boolean} onInit - true только при первом запуске.
 */
InstanceOptions.prototype.set = function(option, onInit) {
  var self = this;
  var _options = self._getOptions();
  var _index;

  //console.debug('InstanceOptions: set: option: ', option);
  option = self.__mutateOption(option);
  //console.debug('InstanceOptions: set: option: mutated: ', option);

  // Пытаемся найти такое значение в опциях
  _index = _findKey(_options, { id: option.option_name_id });
  //console.log('InstanceOptions: set: _index: ', _index);

  //console.log('InstanceOptions: set: onInit: ', onInit);
  if (_isUndefined(onInit)) {
    //console.log('InstanceOptions: set: onInit: isUndefined');
    self.settings.initOption = true;
  }

  if (_options[_index].selected == option.position) {
    //console.debug('InstanceOptions: set: try set current option');
    return;
  }

  _options[_index].selected = option.position;
  _options[_index].current_value = _find(_options[_index].values, { position: option.position });

  return _options;
};

/**
 * @param {number} index
 */
InstanceOptions.prototype.get = function(index, actualValues) {
  var self = this;
  var _options = _cloneDeep(self._getOptions());
  var _settings = self._getSettings();
  var _option;
  var _values;

  //console.debug('InstanceOptions: get: _settings: ', _settings);
  _option = _options[index];

  _values = _sortBy(_toArray(_option.values), [ 'position' ]);

  // Если выводим только актуальные для ветки
  if (_settings.filtered) {
    _values = _intersectionBy(_values, actualValues, 'position');
  }

  const actualValuesMap = new Map();
  actualValues.forEach(function(value) {
    actualValuesMap.set(value.position, value);
  });

  _values = _forEach(_values, function(_value) {
    var _actualValue = actualValuesMap.get(_value.position);
    var _disabled = false;
    var _isOtherBranch = false;
    var _available = false;

    if (!_actualValue) {
      _isOtherBranch = true;
      _disabled = true;
    } else {
      _available = _actualValue.available;

      if (!_settings.selectUnavailable) {
        _disabled = !_available;
      }
    }

    _merge(_value, {
      disabled: _disabled,
      available: _available,
      otherBranch: _isOtherBranch,
    });
  });

  _option.values = _values;

  return _option;
};

/**
 * @private
 *
 * @description
 * Приводим передаваемую опцию к внутреннемму кононичному виду
 *
 * @param {Object} option
 * @param {number} option.option_id - транслируется в option_name_id
 * @param {number} option.option_name_id
 * @param {number} option.position
 * @param {number} option.value_id - заменяется на position
 */
InstanceOptions.prototype.__mutateOption = function(option) {
  var self = this;
  var _options = self._getOptions();
  var _option_id;
  var _position;

  _option_id = option.option_name_id || option.option_id;
  _position = option.position;

  if (option.value_id) {
    // Находим объект с заданным id в _options
    const optionObj = _find(_options, { id: _option_id });

    // Получаем массив values из найденного объекта и берем первый элемент
    const valuesArray = _head(_at(optionObj, 'values'));

    // Находим объект с заданным value_id в массиве values
    const valueObj = _find(valuesArray, { id: option.value_id });

    // Извлекаем значение свойства position из найденного объекта valueObj
    _position = _head(_at(valueObj, 'position'));
  }

  return {
    option_name_id: _option_id,
    position: _position,
  };
};

/**
 * @private
 * @param {number} depth - глубина пути
 */
InstanceOptions.prototype.getSelected = function(depth) {
  var self = this;
  var _vector = [];
  var _options = self._getOptions();

  if (_isUndefined(depth)) {
    depth = _size(_options) - 1;
  }

  _forEach(_options, function(_option, _index) {
    //console.log('InstanceOptions: getSelected: forEach: _option: ', _option);
    _vector.push(_option.selected);

    if (_index == depth) {
      return false;
    }
  });
  //console.log('InstanceOptions: getSelected: _vector: ', depth, _vector);

  return _vector;
};

/**
 * @description
 * Получаем первый элемент из уровня, с учетом настроек
 *
 * @param {Object} treeLevel - актуальный уровень из дерева
 */
InstanceOptions.prototype.getFirst = function(index, treeLevel) {
  var self = this;
  var _level = self.get(index, treeLevel);
  var _values = _level.values;
  var _first;

  //console.debug('InstanceOptions: getFirst: _level: ', _level);
  // отсекаем значения с других веток
  _values = _filter(_values, { otherBranch: false });

  if (this.settings.allowUnavailable) {
    _first = _head(_values);
  } else {
    _first = _head(_filter(_values, { available: true }));
  }

  //console.debug('InstanceOptions: getFirst: _first: ', _first);
  // если весь уровень - недоступен.
  if (_isUndefined(_first)) {
    _first = _head(_values);
  }

  return _first;
};

/**
 *
 */
InstanceOptions.prototype.setConfig = function(settings) {
  var self = this;
  var _options = self._getOptions();

  self.settings = settings.optionSelector;
  //console.debug('InstanceOptions: setConfig: settings: ', self.settings);

  _forEach(_options, function(option) {
    option.renderType = self.settings.options[option.name] || self.settings.options.default;

    option.title = self.settings.labels[option.name] || option.title;
  });
  //console.debug('InstanceOptions: setConfig: settings: ', self.settings);

  return;
};

/**
 * @private
 */
InstanceOptions.prototype._getSettings = function() {
  var self = this;
  var _settings;

  _settings = self.settings;

  return _settings;
};

/**
 *
 */
InstanceOptions.prototype.isEmpty = function() {
  var self = this;
  var _options = self._getOptions();
  var _isEmpty;

  _isEmpty = !!_find(_options, { handle: '_empty' });
  //console.warn('InstanceOptions: isEmpty: _isEmpty: ', _isEmpty);

  return _isEmpty;
};

/**
 *
 */
InstanceOptions.prototype.getStatus = function() {
  var self = this;
  var _status;

  _status = { initOption: self.settings.initOption };

  return _status;
};

export default InstanceOptions;
